export default __webpack_public_path__ + "static/media/adx_logo.554d9f3e.svg";